window._shipScout = window._shipScout || [];
_shipScout.push(function (response) {
    // if (response?.freeShippingThresholdCents) {
    //     DK.freeship = parseInt(response.freeShippingThresholdCents / 100);
    //     sessionStorage.setItem("standard_shipping", parseInt(response.freeShippingThresholdCents / 100));
    //     if(meta.page.pageType == 'product'){
    //         const thresholdPrice = document.querySelector('[data-ss-threshold-price]');
    //         if(thresholdPrice){
    //             thresholdPrice.innerHTML = `$${DK.freeship}`;
    //         }
    //     }
    // }
});